import _ from 'lodash';

import {
  GAME_ID,
  INIT_ONBOARDING,
  INTERRUPT_ONBOARDING,
  INIT_STANDARD_ROUND,
  NEXT_STANDARD_QUESTION,
  COMPLETE_STANDARD_ROUND,
  INTERRUPT_STANDARD_ROUND,
  MARK_PROGRESS,
  ONBOARDING_STATUSES,
  STANDARD_ROUND_STATUSES,
  QUICK_ROUND,
  QUICK_FAIL,
  QUESTIONS_PER_ROUND,
} from '../foodTruckConstants';

const initialState = {
  // list of questions
  questions: [],
  // level id round belongs to
  levelId: null,
  // name of level
  levelName: null,
  // key of current game level (bitsAndBites, etc), coming from json
  levelKey: null,
  // current question index
  currentQuestionIndex: null,
  // user's progress
  progress: 0,
  // status of current round, can be STARTED, INTERRUPTED or COMPLETED
  status: null,
  // amount of times user can cut tile for one standard item, level-specific value, unchangeable
  cutAttemptsLimit: 0,
  // For reporting early exits from onboarding
  onboardingStatus: null,
};

const foodTruckStandardRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case INIT_ONBOARDING:
      return {
        ...state, onboardingStatus: ONBOARDING_STATUSES.STARTED,
      };
    case INIT_STANDARD_ROUND: {
      const {
        name,
        key,
        id,
        cutAttemptsLimit,
        questions,
      } = action.payload;

      return {
        ...initialState,
        questions: _.shuffle(questions),
        levelId: id,
        levelName: name,
        levelKey: key,
        currentQuestionIndex: 0,
        status: STANDARD_ROUND_STATUSES.STARTED,
        cutAttemptsLimit,
      };
    }
    case NEXT_STANDARD_QUESTION: {
      return {
        ...state,
        currentQuestionIndex: state.currentQuestionIndex + 1,
      };
    }
    case COMPLETE_STANDARD_ROUND: {
      return {
        ...state,
        currentQuestionIndex: null,
        status: STANDARD_ROUND_STATUSES.COMPLETED,
      };
    }
    case INTERRUPT_ONBOARDING: {
      return {
        ...state, onboardingStatus: ONBOARDING_STATUSES.INTERRUPTED,
      };
    }
    case INTERRUPT_STANDARD_ROUND: {
      return {
        ...state,
        status: STANDARD_ROUND_STATUSES.INTERRUPTED,
      };
    }
    case MARK_PROGRESS: {
      const { progressIncrement } = action.payload;

      return {
        ...state,
        progress: state.progress + progressIncrement,
      };
    }
    case QUICK_ROUND: {
      return {
        ...state,
        progress: QUESTIONS_PER_ROUND,
        currentQuestionIndex: QUESTIONS_PER_ROUND - 1,
      };
    }
    case QUICK_FAIL: {
      return {
        ...state,
        currentQuestionIndex: QUESTIONS_PER_ROUND - 1,
      };
    }
    default:
      return state;
  }
};

export default foodTruckStandardRoundReducer;
